//CSS
import "../../Components/Page/Page.css";
import graph1 from "../../Images/Investor/AvrgEfficiency.png";
import graph2 from "../../Images/Investor/LogOfWeight.png";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";

const ElfPower: React.FC = () => {
  return (
    <div className="sectionContainer">
      <SecHeader title="The Power of Elf-Tech™ Geometry" />
      <SubSection>
        <ImageComp imageSource={graph1} width={"Clamp(18rem, 30vw, 36rem)"} />
        <ImageComp imageSource={graph2} width={"Clamp(18rem, 30vw, 36rem)"} />
      </SubSection>
      <SubSection isSplit={false}>
        <div className="description-container">
          <p>
            Driven by Our new shapes computer modeling shows Elf-Tech designs consistently demonstrate:
            <ul>
              <li><b>Higher fuel efficiency</b></li>
              <li><b>Reduced emissions</b></li>
              <li><b>Higher power to weight ratio</b></li>
            </ul>
          </p>
        </div>
      </SubSection>
    </div>
  );
};

export default ElfPower;